import * as React from 'react';

import { useTextareaResize } from '@/hooks/use-textarea-resize';
import { cn } from '@/lib/utils';

// TODO: Add make this auto resize
const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<'textarea'> & { startingRows?: number }
>(({ className, startingRows = 3, ...props }, ref) => {
  const textareaRef = useTextareaResize(props.value, startingRows);
  return (
    <textarea
      className={cn(
        'flex min-h-[20px] w-full rounded-md bg-transparent px-3 py-2 text-base placeholder:text-muted-foreground',
        'focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50 md:text-sm resize-none',
        className,
      )}
      ref={ref || textareaRef}
      {...props}
    />
  );
});
Textarea.displayName = 'Textarea';

export { Textarea };
